import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { extractSuffix, ADDITIONAL_CHARGES } from 'helpers/DocumentTemplateHelper';
import { media } from 'helpers/MediaHelper';
import { StyledColumn, StyledRow, LeaseSummaryColumnContent } from '../common/LeaseStyles';
import { getDurationStringInMonths } from '../common/LeaseIncentiveUtils';

const LeaseSummarySectionTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  margin-bottom: 10px;
  clear: both;
  ${media.mobile`
    margin-top: 16px;
    margin-bottom: 0;
  `};
`;

const LeaseSummaryColumnTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 22px;
  ${media.mobile`
    font-size: 16px;
  `};
`;

export default function Pricing({ leaseDetails }) {
  return (
    <>
      <StyledRow>
        <StyledColumn md={8}>
          <LeaseSummarySectionTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.unitPricing'
            )}
          </LeaseSummarySectionTitle>
        </StyledColumn>
      </StyledRow>
      <StyledRow>
        <StyledColumn md={8}>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.monthlyRent'
            )}
          </LeaseSummaryColumnTitle>
          <LeaseSummaryColumnContent>
            {`$${leaseDetails.draft_lease_data.monthly_rent}`}
          </LeaseSummaryColumnContent>
        </StyledColumn>
        <StyledColumn md={8}>
          <LeaseSummaryColumnTitle>
            {getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.rentalDeposit'
            )}
          </LeaseSummaryColumnTitle>
          <LeaseSummaryColumnContent>
            {`$${leaseDetails.draft_lease_data.deposit_amount}`}
          </LeaseSummaryColumnContent>
        </StyledColumn>
      </StyledRow>
      {leaseDetails.draft_lease_data.rentable_items &&
        leaseDetails.draft_lease_data.rentable_items.map((item, index) => (
          <div key={`rentable_items_${index}`}>
            <StyledRow>
              <StyledColumn md={8}>
                <LeaseSummarySectionTitle>{item.asset_type}</LeaseSummarySectionTitle>
              </StyledColumn>
            </StyledRow>
            <StyledRow>
              <StyledColumn md={8}>
                <LeaseSummaryColumnTitle>
                  {getTranslatedString(
                    'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.assetNumber'
                  )}
                </LeaseSummaryColumnTitle>
                <LeaseSummaryColumnContent>{item.asset_id}</LeaseSummaryColumnContent>
              </StyledColumn>
              <StyledColumn md={8}>
                <LeaseSummaryColumnTitle>
                  {getTranslatedString(
                    'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.startDate'
                  )}
                </LeaseSummaryColumnTitle>
                <LeaseSummaryColumnContent>{item.start_date}</LeaseSummaryColumnContent>
              </StyledColumn>
              <StyledColumn md={8}>
                <LeaseSummaryColumnTitle>
                  {getTranslatedString(
                    'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.additionalMonthlyRent'
                  )}
                </LeaseSummaryColumnTitle>
                <LeaseSummaryColumnContent>
                  {`$${item.monthly_rent.toFixed(2)}`}
                </LeaseSummaryColumnContent>
              </StyledColumn>
              <StyledColumn md={8}>
                <LeaseSummaryColumnTitle>
                  {getTranslatedString(
                    'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.duration'
                  )}
                </LeaseSummaryColumnTitle>
                <LeaseSummaryColumnContent>
                  {getDurationStringInMonths(item.term_length)}
                </LeaseSummaryColumnContent>
              </StyledColumn>
              <StyledColumn md={8}>
                <LeaseSummaryColumnTitle>
                  {getTranslatedString(
                    'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.keyDeposit'
                  )}
                </LeaseSummaryColumnTitle>
                <LeaseSummaryColumnContent>
                  {`$${item.key_deposit.toFixed(2)}`}
                </LeaseSummaryColumnContent>
              </StyledColumn>
              <StyledColumn md={8}>
                <LeaseSummaryColumnTitle>
                  {getTranslatedString(
                    'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.additionalRentalDeposit'
                  )}
                </LeaseSummaryColumnTitle>
                <LeaseSummaryColumnContent>
                  {`$${item.deposit_amount.toFixed(2)}`}
                </LeaseSummaryColumnContent>
              </StyledColumn>
            </StyledRow>
          </div>
        ))}
      {leaseDetails.draft_lease_data.additional_charges &&
        leaseDetails.draft_lease_data.additional_charges.map((item, index) => (
          <div key={`additional_charges_${index}`}>
            <StyledRow key={index}>
              <StyledColumn md={8}>
                <LeaseSummarySectionTitle>
                  {getTranslatedString(
                    'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.additionalCharge'
                  )}{' '}
                  #{index + 1}
                </LeaseSummarySectionTitle>
              </StyledColumn>
            </StyledRow>

            <StyledRow>
              <StyledColumn md={8}>
                <LeaseSummaryColumnTitle>
                  {getTranslatedString(
                    'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.chargeAmount'
                  )}
                </LeaseSummaryColumnTitle>
                <LeaseSummaryColumnContent>{`$${item.default_amount}`}</LeaseSummaryColumnContent>
              </StyledColumn>
              <StyledColumn md={8}>
                <LeaseSummaryColumnTitle>
                  {getTranslatedString(
                    'landlordPortal.leaseCreatorV2.leaseSummaryPage.pricing.description'
                  )}
                </LeaseSummaryColumnTitle>
                <LeaseSummaryColumnContent>
                  {extractSuffix(item.name, ADDITIONAL_CHARGES)}
                </LeaseSummaryColumnContent>
              </StyledColumn>
            </StyledRow>
          </div>
        ))}
    </>
  );
}
